import {ActionEnum} from "../action.enum";
import {DocumentGroupModel} from "../../models/document/document-group.model";
import {DocumentGroupBasicInfoUpdateModel} from "../../models/document/document-group-basic-info-update.model";

export namespace FilesDetailAction {

  export class Fetch {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_FETCH;
    constructor (public id: string) {}
  }

  export class ResetState {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_RESET;
  }

  export class Update {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_UPDATE;

    constructor(public documentGroup: DocumentGroupBasicInfoUpdateModel) {
    }
  }


  export class Delete {
    static readonly type: ActionEnum = ActionEnum.FILES_DETAIL_DELETE;

    constructor() {
    }
  }


}
